module.exports = __webpack_public_path__ + "static/media/Tempel_segesta_tn.fc6957cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/Tempel_segesta_tn.jpg
// module id = 766
// module chunks = 0